import React, { memo } from 'react';
import { styled } from '@mui/material/styles';
import { ExcelExportParams, GridApi } from 'ag-grid-community';
import GetAppIcon from '@mui/icons-material/GetApp';
import TooltipIconButton from 'components/TooltipIconButton';
import { useTranslation } from 'react-i18next';

type Props = {
    gridApi: GridApi | null;
    exportOptions: ExcelExportParams;
    isDisabled?: boolean;
    trackEvent?: () => void;
};

export const StyTooltipIconButton = styled(TooltipIconButton, {
    name: 'StyTooltipIconButton',
})(({ theme }) => ({
    height: '26px',
    minHeight: '26px',
    color: theme.palette.primary.main,
}));

const ExportButton = ({
    gridApi,
    exportOptions,
    isDisabled,
    trackEvent,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <StyTooltipIconButton
            tooltip={t('common.export')}
            onClick={() => {
                gridApi?.exportDataAsExcel({
                    ...exportOptions,
                });
                trackEvent?.();
            }}
            icon={<GetAppIcon />}
            isDisabled={isDisabled}
        />
    );
};

export default memo(ExportButton);
